import { CollectionViewer, DataSource } from "@angular/cdk/collections";
import { Observable, BehaviorSubject, of } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { QueryParameter } from "../helpers/queryParameter";
import { ApiService } from "./api.service";

export class ModelsDataSource implements DataSource<any> {
  public ModelsSubject = new BehaviorSubject<any[]>([]);

  private loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();
  public totalItems = 0;
  public head = {};
  public ids = [];
  public pageSize: number;
  public query: QueryParameter;

  constructor(private modelDefinition: any, private api: ApiService) {}
  // tslint:disable-next-line:no-shadowed-variable
  loadInstances(query: QueryParameter, instance?: any) {
    this.loadingSubject.next(true);
    this.query = query;
    this.api
      .findModelList(this.modelDefinition, query)
      .pipe(
        catchError(() => of([])),
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe((models: any) => {
        this.head = models.Head;
        this.totalItems = models.TotalItems;
        this.ModelsSubject.next(models.Items);

        this.pageSize = models.Items?.length;
        this.ids = models.Items.map((item) => item.id);
      });
  }

  connect(collectionViewer: CollectionViewer): Observable<any[]> {
    // console.log('Connecting data source');
    return this.ModelsSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.ModelsSubject.complete();
    this.loadingSubject.complete();
  }
}
